<template>
  <div class="h5" style="padding-top: 50px;">
    <div class="banner">
      <img src="../../static/image/gsjj.png" alt />
    </div>
    <div class="conter">
      <h2 class="title">公司简介</h2>
       <div v-html="Introduction">

       </div>
      <div class="jj_img">
        <img src="../../static/image/gsjj1.png" alt />
        <img src="../../static/image/gsjj2.png" alt />
        <img src="../../static/image/gsjj3.png" alt />
      </div>
    </div>
    <div class="certificate">
      <h2
        style="text-align:center;font-size:36px;color:rgba(51, 51, 51, 1);font-weight:400;font-family:Microsoft YaHei;"
      >证件资质</h2>
      <div class="certificate_swiper">
        <!-- Swiper -->
        <Carousel class="swiper" arrow="always" dots="outside">
          <Carousel-item v-for="(item,i) in swiper_list" :key="i">
            <div class="demo-carousel">
              <ul class="img_list">
                <li v-for="(itemc,index) in item" :key="index">
                  <div
                    class="content"
                    :style="{'background':'url('+itemc.pic_url+')no-repeat center center','background-size':'50%'}"
                    @click="preview_img(itemc.pic_url)"
                  >
                    <!-- <img :src="itemc.pic_url" alt=""> -->
                  </div>
                </li>
              </ul>
            </div>
          </Carousel-item>
        </Carousel>
      </div>
    </div>
    <div class="msk" v-if="isShow">
      <div
        class="msk_img"
        :style="{'background':'url('+big_img+')no-repeat center center','background-size':'80%','width':(screenWidth/4.44)+'px','height':(screenHidth/1.8)+'px'}"
      >
        <img src="../../static/image/gb.png" alt class="guanbi" @click="guanbi" />
      </div>
    </div>
    <xfck></xfck>
  </div>
</template>

<script>
import xfck from "./xfck.vue";
export default {
  name: "htmls",
  data() {
    return {
      swiper_list: [],
      big_img: "",
      isShow: false,
      Introduction:'',
      screenWidth:'',
      screenHidth:''
    };
  },
  components: {
    xfck
  },
  created() {
    this.get_qualification();
    this.get_Introduction();
    this.getShowClient()
  },
  methods: {
    get_qualification() {
      var that = this;
      var url = that.baseUrl + "/jianyun/api/mall.php?c=about_us/getPic";
      that.axios
        .get(url, {
          params: {
            pic_type: 2
          }
        })
        .then(res => {
          if (res.data.success) {
            for (var i = 0; i <res.data.data.list.length; i) {
              that.swiper_list.push(res.data.data.list.slice(i, (i +=6)));
            }
            console.log(that.swiper_list)
          } else {
            this.$Message.warning(res.data.msg);
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    get_Introduction() {
      var that = this;
      var url =
        that.baseUrl + "/jianyun/api/mall.php?c=about_us/getCompanyInfo";
      that.axios
        .get(url, {
          params: {
            type: 1
          }
        })
        .then(res => {
          if (res.data.success) {
            that.Introduction = res.data.data
          } else {
            this.$Message.warning(res.data.msg);
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    preview_img(item) {
      console.log(item);
      this.big_img = item;
      this.isShow = true;
    },
    guanbi() {
      this.isShow = false;
    },
        //获取屏幕的宽高
    getShowClient(){
      this.screenWidth=window.screen.width
      this.screenHidth =window.screen.height
      console.log(this.screenWidth)
      console.log(this.screenHidth)
    },
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.banner {
  width: 100%;
}
.banner > img {
  width: 100%;
  height: 100%;
}
.conter {
  width: 1200px;
  padding: 50px 0;
  margin: 0 auto;
}
.title {
  text-align: center;
  color: rgba(51, 51, 51, 1);
  font-size: 36px;
}
.conter p {
  margin: 20px 0;
  color: rgba(102, 102, 102, 1);
  font-size: 14px;
  font-weight: Light;
  font-family: MicrosoftYaHeiLight;
}
.jj_img {
  display: flex;
  justify-content: space-between;
}
.jj_img img {
  width: 380px;
  height: 260px;
}
.certificate {
  width: 100%;
  background: rgba(247, 244, 248, 1);
  padding: 20px 0;
}
.certificate_swiper {
  width: 1200px;
  margin: 69px auto;
}
.demo-carousel .img_list {
  list-style: none;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.demo-carousel .img_list li {
  width: 380px;
  height: 300px;
  border: 1px solid #cccccc;
  display: flex;
  justify-content: center;
  align-items: center;
}
.demo-carousel .img_list li div.content {
  width: 360px;
  height: 280px;
  border: 1px solid #cccccc;
  cursor: pointer;
}
.msk {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgb(0, 0, 0, 0.5);
}
.msk .msk_img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: pink;
}
.guanbi {
  position: absolute;
  right: 0px;
  top: -60px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Companyprofile.vue